import Vue from "vue";
import VueI18n from "vue-i18n";

// Localisation language list
import { locale as fa } from "./core/services/langs/fa";
import { locale as ar } from "./core/services/langs/ar";
import { locale as ar_ae } from "./core/services/langs/ar_ae";
import { locale as ar_iq } from "./core/services/langs/ar_iq";
import { locale as de } from "./core/services/langs/de";
import { locale as en_GB } from "./core/services/langs/en_GB";
import { locale as en_US } from "./core/services/langs/en_US";
import { locale as fr } from "./core/services/langs/fr";
import { locale as hy } from "./core/services/langs/hy";
import { locale as ru } from "./core/services/langs/ru";
import { locale as tr } from "./core/services/langs/tr";
import { locale as zh_CN } from "./core/services/langs/zh_CN";
import { locale as zh_TW } from "./core/services/langs/zh_TW";

import { getLanguageCookie } from "./core/plugins/TitleRibbon/utils/languageCookie";

Vue.use(VueI18n);

let messages = {};
messages = {
  ...messages,
  fa,
  ar,
  ar_ae,
  ar_iq,
  de,
  en_GB,
  en_US,
  fr,
  hy,
  ru,
  tr,
  zh_CN,
  zh_TW,
};

const lang = getLanguageCookie() || "fa";

const i18n = new VueI18n({
  locale: lang,
  messages,
});

export default i18n;
